// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"662":"499ad1bc70a8dffcc5c2","966":"3beacba57a0d16850cf5"}[chunkId] + ".js";
};